import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startLoading,
  stopLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';

export const fetchServiceRequestsDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUESTS_DONE,
  payload,
});

export const fetchServiceRequestsSearchDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUESTS_SEARCH_DONE,
  payload,
});

export const fetchServiceRequestByPropertyIdUserIdRole =
  (propertyId, userId, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }

    return client
      .getServiceRequestByPropertyIdUserIdRole(
        propertyId,
        userId,
        role,
        count,
        text
      )
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

export const fetchServiceRequestByCommonAreaIdUserIdRole =
  (propertyId, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }
    return client
      .getServiceRequestByCommonIdUserIdRole(propertyId, role, count, text)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

export const clearServiceRequests = () => ({
  type: TYPES.CLEAR_SERVICE_REQUESTS_DONE,
});

export const savePaginationCount = (payload) => ({
  type: TYPES.SERVICE_REQUEST_PAGINATION,
  payload,
});

export const clearPaginationCount = (payload) => ({
  type: TYPES.CLEAR_PAGINATION_COUNT,
  payload,
});

export const savePageCount = (payload) => ({
  type: TYPES.SERVICE_REQUEST_PAGE_COUNT,
  payload,
});

export const clearPageCount = (payload) => ({
  type: TYPES.CLEAR_PAGE_COUNT,
  payload,
});
export const updateServiceRequestsStatusDone = (payload) => ({
  type: TYPES.UPDATE_SERVICE_REQUEST_STATUS_DONE,
  payload,
});

export const archiveServiceRequest = (payload) => ({
  type: TYPES.ARCHIVE_SERVICE_REQUESTS_DONE,
  payload,
});

export const updateBulkStatus = (params, role, params1, from) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateBulkStatus(params)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            if (params.name === 'Archive') {
              dispatch(archiveServiceRequest(params));
            } else {
              dispatch(updateServiceRequestsStatusDone(params));
            }
            if (from === 'serviceRequest') {
              window.history.back();
            } else if (from === 'Property') {
              dispatch(
                fetchServiceRequestByPropertyIdUserIdRole(
                  params.propertyId,
                  params1.userID,
                  role,
                  1,
                  ''
                )
              );
            }
            dispatch(stopFormLoading());
            toast.success(' ⓘ The service requests status has been updated.', {
              autoClose: 5000,
              position: 'top-center',
            });
          } else {
            dispatch(stopFormLoading());
            toast.error(
              ' 🚫 Something went wrong with updating a service requests status, please try again.',
              { autoClose: 5000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with updating a service requests status, please try again.',
          { autoClose: 5000, position: 'top-center' }
        );
        dispatch(stopFormLoading());
      }
    })
    .catch(() => {
      toast.error(
        ' 🚫 Something went wrong with updating a service requests status, please try again.',
        { autoClose: 5000, position: 'top-center' }
      );
      dispatch(stopFormLoading());
    });
};
